import React, { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AuthContext from "../../context/auth/authContext";
import ErrorLogger from "../ErrorLogger";
import setAuthToken from "../../functions/auth_header";
import { getAppUrl } from "../../functions/getEnv";

const EditCourseRow = ({
  info: { name, charter, charter_id, id },
  courseid,
  permalink,
}) => {
  const navigate = useNavigate();
  const [courseTypes, setCourseTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const authContext = useContext(AuthContext);
  const { user } = authContext;

  const isCharterAssigned = useMemo(() => {
    if (user?.userStatus === "Super Admin") return true;
    const assignedCharters = user?.charterAssignments?.map((a) => a.name) || [];
    return assignedCharters.includes(charter);
  }, [user, charter]);

  useEffect(() => {
    if (!isCharterAssigned) {
      setLoading(false);
      return;
    }

    const fetchCourseNames = async () => {
      try {
        if (localStorage.token) {
          setAuthToken(localStorage.token);
        }

        let response;
        if (user.userStatus === "Super Admin") {
          response = await axios.get(`${appUrl}/api/courses/${id}/${charter_id}/${courseid}`);
        } else {
          const assignedCharters = user.charterAssignments.map(
            (assignment) => assignment.name
          );
          response = await axios.get(`${appUrl}/api/courses/${id}/${charter_id}/${courseid}`, {
            params: { charter_ids: assignedCharters.join(",") },
          });
        }

        const filteredCourses = response.data.filter(
          (course) =>
            course.learningCenterName === name &&
            course.charter_id === charter_id &&
            course.LeloRegistrationProfile === courseid &&
            course.siteId === id
        );

        const coursesByType = filteredCourses.reduce((acc, course) => {
          if (!acc[course.course_type]) {
            acc[course.course_type] = [];
          }
          acc[course.course_type].push(course.course_name);
          return acc;
        }, {});

        setCourseTypes(coursesByType);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching course names:", error);

        setLoading(false);
        ErrorLogger.logError(error.message);
      }
    };

    fetchCourseNames();
  }, [isCharterAssigned, charter_id, name, courseid, appUrl, user]);

  if (!isCharterAssigned) {
    return null;
  }

  const navigateToEditCourses = () => {
    if (Object.keys(courseTypes).length === 0) {
      navigate(
        `/edit-courseOfferings/${charter}/${charter_id}/${name}/${courseid}/${permalink}/${id}`
      );
    } else {
      navigate(
        `/edit-Finalcourse/${charter}/${charter_id}/${name}/${courseid}/${permalink}/${id}`
      );
    }
  };

  const renderCourseNames = () => {
    if (Object.keys(courseTypes).length === 0) {
      return null;
    }

    const sortedCourseTypes = Object.keys(courseTypes).sort((a, b) => {
      if (a === "High School") return -1;
      if (b === "High School") return 1;
      if (a === "Middle School") return -1;
      if (b === "Middle School") return 1;
      if (a === "Elementary School") return -1;
      if (b === "Elementary School") return 1;
      return a.localeCompare(b);
    });

    return (
      <div>
        {sortedCourseTypes.map((type, index) => (
          <div key={index} style={{ marginBottom: "10px" }}>
            <h4>{type}:</h4>
            <p>{courseTypes[type].join(", ")}</p>
          </div>
        ))}
      </div>
    );
  };

  return (
    <tr>
      <td>{charter}</td>
      <td>{name}</td>
      <td>
        {loading ? (
          <span>Loading...</span>
        ) : error ? (
          <span>{error}</span>
        ) : (
          renderCourseNames()
        )}
      </td>
      <td>
        <div
          className="btn btn-llac-dark-green"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={navigateToEditCourses}
        >
          Edit
        </div>
      </td>
    </tr>
  );
};

export default EditCourseRow;
